export default [
  {
    path: '/organizasyon',
    name: 'organizasyon',
    component: () => import('./OrganizationTree.vue'),
    meta: {
      public: false,
      title: "organizasyon.Organizasyon_Semasi",
      yetki: { k: [1180202] },
    },
  },
  {
    path: '/organizasyon/basliklar',
    name: 'organizasyon-basliklari',
    component: () => import('./OrganizasyonBasliklari.vue'),
    meta: {
      public: false,
      title: "organizasyon.Organizasyon_Basliklari",
      yetki: { k: [1180102] },
    },
  },
]
